// extracted by mini-css-extract-plugin
export default {"positions__status":"ReqPositionTable_positions__status__01Kt+","table-cell--bold":"ReqPositionTable_table-cell--bold__23wDC"};